import {Team, TeamUser} from '../model/Team';

export default function getInviteCode(team: Team, user: TeamUser) {
  return window.location.protocol + '//' + window.location.host + '/?invite='
    + btoa(`${user.email}:${team.id}:${user.id}`)
}